<template>
    <div class='messageview'>
        <div v-if="!this.messages">
                Lade Nachrichten...
                <font-awesome-icon icon="spinner" spin/>
        </div>
        <div v-if="this.messages">
            <div v-if="!this.messages.length">
                Keine Nachrichten verfügbar.
            </div>
            <div v-for="(message, index) in messages" :key="message.id">
                <div class="message">
                    
                    <h3>
                        <span v-if='index < unread'><font-awesome-icon icon="circle" :style="{ fontSize: '50%', paddingBottom: '5px' }"/></span>
                        {{ message.title }}
                    </h3>
                    <p v-html="getMessageBody(message.body)"></p>
                    <small>Gesendet: {{ message.senddate_format }}</small>
                </div>                
            </div>            
        </div>
    </div>    
</template>
<script>
 
export default {
    name: 'Messageview',
    data() {
        return {            
            messages: false, 
            count: 0,
            unread: 0,
            token: this.$parent.logintoken
        }
    },
    created() {
        var self = this;
        this.unread = this.$parent.messages;
        if (self.$ms.isOnline()){
            self.$log.debug("apiMessages logintoken", self.$parent.logintoken);
            self.$ms.apiMessages(self, self.$parent.logintoken, function(err, data) {
                self.$log.debug("apiMessages callback begin");
                if (!err)
                    {
                    self.messages = data;
                    self.$parent.messages = 0;
                    }
                else {
                    self.$log.warn('msAxios meldet: ' + err);
                    if (!cacheFound) {
                        self.$ms.showError(self, 'Die gewünschte Ressource konnte nicht geladen werden.');
                    }
                }
            });
        }

    },
    methods:{
        getMessageBody(messageBody) {
            return messageBody.replace(/\\r\\n/g,"<br>");            
        }
    }
}
</script>

<style lang="css" src="../assets/css/Messageview.css"/>